import { Flex } from 'UI';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { FONT_WEIGHT, TextColor } from 'styles/constants';
import { Item } from './Item';
import { IHeightAnswer } from 'modules/survey/helpers';

interface ToggleValue {
	value?: string;
	label?: string;
}

interface Props {
	values?: ToggleValue[];
	value?: string;
	onChange?: (value?: string, heightAnswer?: IHeightAnswer) => void;
	backgroundColor?: string;
	backgroundColorHover?: string;
	backgroundColorSelected?: string;
	titleColor?: string | TextColor;
	titleColorSelected?: string | TextColor;
	titleSize?: number;
	titleWeight?: number | FONT_WEIGHT;
	height?: number;
	borderRadius?: number;
	heightAnswer?: IHeightAnswer;
}

const Container = styled.div`
	width: 100%;
	overflow: hidden;
	border-radius: 5px;
`;

export const ToggleButton: FC<Props> = props => {
	const { values = [], value, onChange, borderRadius, heightAnswer } = props;
	const [state, setState] = useState<string | undefined>(value ?? values[0].value);

	const handleClick = (value?: string, heightAnswer?: IHeightAnswer): void => {
		onChange?.(value, heightAnswer);
		setState(value);
	};
	return (
		<Container>
			<Flex>
				{values?.map(val => (
					<Item
						{...props}
						{...val}
						key={val.value}
						selected={value ? value === val.value : state === val.value}
						onClick={handleClick}
						borderRadius={borderRadius}
					/>
				))}
			</Flex>
		</Container>
	);
};
